export const multiWktSortableId = '-multiWkt'
